import React from 'react'

import PropTypes from 'prop-types'

import { InfoTextList, InfoTextListItem } from './styled'

const List = ({ keys }) => (
  <InfoTextList>
    {keys.map((txt, index) => {
      return txt && <InfoTextListItem dangerouslySetInnerHTML={{ __html: txt }} key={index} />
    })}
  </InfoTextList>
)

List.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string)
}
export default List
